module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8rzkN"))).then(() => module.bundle.root('2KbAe'));